import React, {Fragment} from 'react';
import TextInput from '../form/TextInput';
import CheckBox from '../form/CheckBox';
import AddressControl from '../form/AddressControl';
import List from '../form/list';
import SelectorGrid from '../form/SelectorGrid/SelectorGrid';
import { AddressFormatter } from '../../utils/formatters.js';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import Tabs from '../layout/Tabs';
import Button from "../form/Button";

class CompanyEditor extends React.Component {

	render() {
		const sortable = true;
		const filterable = true;
		return (
            <Fragment>
				<Box
					theme="default"
				>
                    <SelectorGrid
                        componentConfig={this.props.componentConfig}
                        idfield="partner_id"
                        filter={[{column: 'component', value: 'company'}]}
                        columns={ {
                            partner_id: {width:1, sortable},
                            name: {width:5, filterable, sortable},
                            address: {width:6, filterable, renderer: AddressFormatter}
                        } }
                        pageSize={5}
                        orderBy={{field: this.props.componentConfig.idfield, direction: "ASC"}}
                        onSelectionChange={ (selection) => this.props.loadForm(selection.value) }
                        selection={this.props.selection}
                    />
				</Box>
				<Tabs
					ref={(el)=>(this.editorEl = el)}
					width="6"
					theme="default"
					defaultTab="base-data"
					/*header={ <SelectorCombo optionname="company" matchmode="any" placeholder="Keresés..." formLoader={ this.props.loadForm }/> }*/
				>
					<form tabLabel="Alapadatok" tabName="base-data" onSubmit={ this.props.handleSubmit }>
						<div className="row form-row">
							<div className="col-sm-4 col-sm-push-8">
								<TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
							</div>
							<div className="col-sm-8 col-sm-pull-4">
								{/*<AutoComplete name="name" label="Név" optionname="company" value={ this.props.values.name } saveChanges={ this.props.setFieldValue } onSelect={ this.props.loadForm }/>*/}
								<TextInput name="name" value={ this.props.values.name } label="Név" saveChanges={ this.props.setFieldValue }/>
							</div>
						</div>
						<div className="row form-row">
							<div className="col-sm-6">
								<TextInput name="taxid" value={ this.props.values.taxid || ''} label="Adószám" saveChanges={ this.props.setFieldValue }/>
							</div>
							<div className="col-sm-6">
								<TextInput name="eu_taxid" value={ this.props.values.eu_taxid || '' } label="EU adószám" saveChanges={ this.props.setFieldValue }/>
							</div>
						</div>
						<AddressControl value={ this.props.values.address } label="Cím" saveChanges={ this.props.setFieldValue }/>
						<div className="row form-row">
							<div className="col-sm-4">
								<TextInput name="tel" value={ this.props.values.tel || ''} label="Telefon" saveChanges={ this.props.setFieldValue }/>
							</div>
							<div className="col-sm-8">
								<TextInput name="email" value={ this.props.values.email || '' } label="Email cím" saveChanges={ this.props.setFieldValue }/>
							</div>
						</div>
						<div className="row form-row">
							<div className="col-sm-6">
								<CheckBox name="active" value={this.props.values.active} label="Aktív" saveChanges={ this.props.setFieldValue } />
							</div>
							<div className="col-sm-6">
								<TextInput name="checked" value={ this.props.values.checked } label="Ellenőrizve" disabled="true" />
							</div>
						</div>
						<div className="row form-row">
							<div className="col-sm-12">
								<List
									name="tradenames"
									value={ this.props.values.tradenames }
									label="Gyártó nevek"
									saveChanges={ this.props.setFieldValue }
									cols={ [{field: "name"}] }
								/>
							</div>
						</div>
						<div className="row form-row">
							<div className="col-sm-12">
								<Button key="0" disabled={ !this.props.dirty } color="primary" className="pull-right" onClick={ this.props.saveForm }>
									Mentés
								</Button>
								<Button key="1" disabled={ !this.props.values.id>0 } color="warning" className="pull-right" onClick={ this.props.deleteForm }>
									Törlés
								</Button>
								<Button key="2" color="default" className="pull-left" onClick={ this.props.pristineForm }>
									Új
								</Button>
							</div>
						</div>
					</form>
				</Tabs>
			</Fragment>
		);
	}
}
export default createEditor({componentName: "partner", WrappedComponent: CompanyEditor});
